import{classAdderBuilder as d}from"../../common/dist/classadder/classAdderBuilder.js";var e=d({class:"mdc-text-field-helper-line",tag:"div"});export{e as default};
//# sourceMappingURL=HelperLine.js.map
